import { useTranslation } from 'react-i18next';
import { useDecimalPlaces } from '@/hooks/useDecimalPlaces';

// The table renders dummy placeholder rows during loading to prevent layout jumps.
// The dummy row count is hardcoded (MAX_*_BIO_ROW_COUNT) and must match the real row count.
// This assertion catches any drift between the two in development.
export const assertBioRowCount = (rows: unknown[], expected: number) => {
  if (process.env.NODE_ENV !== 'production' && rows.length !== expected) {
    throw new Error(`Bio row count (${rows.length}) is out of sync with expected count (${expected})`);
  }
};

export const useFormatMinutesPlayed = () => {
  const { t } = useTranslation(['filters']);
  const formatDecimal = useDecimalPlaces();
  return (minutes: number) => {
    if (minutes <= 0) return '-';
    const per90s = formatDecimal(1, minutes / 90);
    return `${t('summary.totalMinutes', { ns: 'filters', value: formatDecimal(0, minutes) })} (${per90s} 90s)`;
  };
};
